/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/feature_flags/:rollout_id/dependencies" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdFeatureFlagsRolloutIdDependencies } from "./constants";
import type { FeatureFlagsRolloutDependenciesResults } from "./types";
import { isFeatureFlagsRolloutDependenciesResults } from "./validators";

export const getEngagementAppGroupIdFeatureFlagsRolloutIdDependencies = reactQueryFetcherAdapter(
  engagementAppGroupIdFeatureFlagsRolloutIdDependencies,
  (signal: AbortSignal, appGroupId: string, rolloutId: string): Promise<FeatureFlagsRolloutDependenciesResults> => {
    return fetch(`/engagement/${appGroupId}/feature_flags/${rolloutId}/dependencies`, "GET", {}, { signal });
  },
  isFeatureFlagsRolloutDependenciesResults
);
